// cyrb53: synchronous 53-bit string hash, so test ids carry no customer data yet stay stable per value.
export const hashTestIdValue = (value) => {
    let h1 = 0xde_ad_be_ef;
    let h2 = 0x41_c6_ce_57;
    for (let i = 0; i < value.length; i++) {
        const code = value.charCodeAt(i);
        h1 = Math.imul(h1 ^ code, 2_654_435_761);
        h2 = Math.imul(h2 ^ code, 1_597_334_677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2_246_822_507);
    h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3_266_489_909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2_246_822_507);
    h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3_266_489_909);
    return (4_294_967_296 * (2_097_151 & h2) + (h1 >>> 0)).toString(36);
};
